/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import * as ResourcesConstants from 'constants/ResourcesConstants'
import { encodeQueryData, getAuthorizationHeader } from 'utils/Helpers'
import { RequestContentType } from 'utils/Helpers'

const IntegrationsAPI = Marty.createStateSource({
  id: 'IntegrationsAPI',
  type: 'http',
  baseUrl: ResourcesConstants.CUSTOMER_API,

  mapSlackUser(slackUserId) {
    return this.post({
      url: '/integrations/slack/map_user',
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(),
      body: JSON.stringify({ slackUserId })
    })
  },

  getStateParam() {
    return this.get({
      url: '/integrations/slack/state',
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader()
    })
  },

  createSlackBotToken(code, href) {
    const queryParams = (href != null) ? encodeQueryData({ redirectUri: href }) : ''
    return this.post({
      url: `/integrations/slack/activate_bot?${ queryParams }`,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(),
      body: JSON.stringify({ code })
    })
  },

  createAccessToken(name, body) {
    return this.post({
      url: `/integrations/${name}/access_token`,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(),
      body: JSON.stringify(body)
    })
  },

  integrationStates() {
    return this.get({
      url: '/integrations',
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader()
    })
  },

  enableShopifyIntegration(state) {
    return this.post({
      url: `/integrations/shopify?enable=#${state}`,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader()
    })
  },

  hubspotInjectionState() {
    return this.get({
      url: '/integrations/hubspot/js/inject',
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader()
    })
  },

  hubspotTimelineState() {
    return this.get({
      url: '/integrations/hubspot/timeline',
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader()
    })
  },

  updateHubspotInjectionState(state) {
    return this.post({
      url: `/integrations/hubspot/js/inject?enable=${state}`,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader()
    })
  },

  updateHubspotTimelineState(state) {
    return this.post({
      url: `/integrations/hubspot/timeline?enable=${state}`,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader()
    })
  },

  hubspotCookieState() {
    return this.get({
      url: '/integrations/hubspot/cookie',
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader()
    })
  },

  updateHubspotCookieState(state) {
    return this.post({
      url: `/integrations/hubspot/cookie?enable=${state}`,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader()
    })
  },

  updateIntegrationState(properties) {
    return this.patch({
      url: '/integrations',
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(),
      body: JSON.stringify(properties)
    })
  },

  protip(key) {
    return this.get({
      url: `/protips/${key}`,
      contentType: RequestContentType.JSON
    })
  }
})

export default IntegrationsAPI



// WEBPACK FOOTER //
// ./src/scripts/sources/IntegrationsAPI.js